import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PaymentData, paymentStatus } from "../../../types/paymentType";

const initialState: paymentStatus = {
  paymentData: {
    txn_amount: "",
    txn_status: "",
    txn_orderid: "",
    txn_txnid: "",
    txn_time: "",
  },
  paymentStatus: "PENDING",
};

const paymentStatusSlice = createSlice({
  name: "paymentStatus",
  initialState,
  reducers: {
    updatePaymentData: (state, action: PayloadAction<PaymentData>) => {
      state.paymentData = action.payload;
    },
    updatePaymentStatus: (state, action: PayloadAction<string>) => {
      state.paymentStatus = action.payload;
    },
  },
});

export const { updatePaymentData, updatePaymentStatus } =
  paymentStatusSlice.actions;
export default paymentStatusSlice.reducer;
